import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import {
  PATH_PARAMETERS_CONFIGURATIONS,
  PATH_PARAMETERS_CONFIGURATIONS_UID,
} from "~/modules/globalConfiguration/constants";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_CONFIGURATIONS,
    component: () =>
      import("~/modules/globalConfiguration/views/GlobalConfigurationsPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_CONFIG),
      breadcrumb: BREADCRUMBS.GLOBAL_CONFIGURATION,
    },
  },
  {
    path: PATH_PARAMETERS_CONFIGURATIONS_UID,
    component: () =>
      import("~/modules/globalConfiguration/views/GlobalConfigurationsPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_CONFIG),
      breadcrumb: BREADCRUMBS.GLOBAL_CONFIGURATION,
    },
  },
];

export default routes;
